"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SilentCallback = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const authentication_service_1 = require("../authentication-service");
const SilentCallback = () => {
    react_1.useEffect(() => {
        authentication_service_1.getUserManager().signinSilentCallback();
    }, []);
    return react_1.default.createElement("div", null);
};
exports.SilentCallback = SilentCallback;
//# sourceMappingURL=silent-callback.js.map